import { Validator, NG_VALIDATORS, AbstractControl } from "@angular/forms";
import { Directive, Input } from '@angular/core';
import * as moment from 'moment';
@Directive({
  selector: '[appTimeValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: TimeValidatorDirective,
    multi: true
  }]
})

export class TimeValidatorDirective implements Validator {
  @Input() appEqualValidator: string;
  validate(control: AbstractControl): { [key: string]: any } | null {
    if (moment(control.value, 'HHmm').isValid() || control.value == null) {
      return null;
    }
    return { 'invalid': true };
  }
}
